import React, { useMemo, useCallback } from "react";
import useForm from "./hooks/useForm";
import useCMS from "./hooks/useCMS";
import { pattern } from "./utils";
import { useState, useDispatch } from "./hooks/useState";
import DateInput from "./ui/DateInput";
import TypeOfReport from "./ui/TypeOfReport";
import { usePost } from "./hooks/useApi";
import Button from "./ui/Button";

const REPORT_TYPE = "ReportType";
const LAST_SICK_DAY = "LastSickDay";

function ReportReturn() {
  const { translations } = useCMS();
  const { lime, reportReceived, formType, token } = useState();
  const { setSuccess, setError } = useDispatch();
  const { handleSubmit, formState, registerField, fieldRequired } = useForm();

  const onResolve = useCallback(
    res => {
      const { ErrorCode } = res.data;
      if (ErrorCode) {
        setError(ErrorCode);
      } else {
        setSuccess("submitsuccesshealthy");
      }
    },
    [setError, setSuccess]
  );
  const { post, pending } = usePost("CloseSickReport", { onResolve });

  const minDate = useMemo(() => new Date(reportReceived.replace(" ", "T")), [
    reportReceived
  ]);
  const onSubmit = useCallback(
    data => {
      post({ ...data, ...lime, Token: token });
    },
    [post, lime, token]
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <TypeOfReport
        {...registerField(REPORT_TYPE)}
        values={[{ value: formType, text: translations.wellnessreport }]}
      >
        {translations.typeofreport}
      </TypeOfReport>

      <DateInput
        {...registerField(LAST_SICK_DAY, true)}
        required={fieldRequired}
        minDate={minDate}
        pattern={pattern.date}
      >
        {translations.lastdayofabsense}
      </DateInput>

      <Button
        type="submit"
        loading={formState.isSubmitting || formState.isSubmitted}
        disabled={
          !formState.isValid || 
          pending || 
          formState.isSubmitting || 
          formState.isSubmitted
        }
      >
        {translations.send}
      </Button>
    </form>
  );
}

export default ReportReturn;
